import React from "react";
import { RaisedButton, TextField } from "material-ui";

import {
  injectStripe,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement
} from "react-stripe-elements";

class PaymentMethodEntry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      isCreatingToken: false,
      tokenCreationErrorMessage: null
    };

    this.onFieldChange = this.onFieldChange.bind(this);
    this.submitPaymentInfo = this.submitPaymentInfo.bind(this);
  }

  static get contextTypes() {
    return {
      isLarge: React.PropTypes.bool
    };
  }

  static getStores() {
    return [PersonStore];
  }

  static getPropsFromStores() {
    return PersonStore.getState();
  }

  getStyles() {
    return {
      form: {
        maxWidth: 400,
        margin: "0 auto"
      },
      actions: {
        marginTop: "1em"
      },
      error: {
        color: "#FF4136",
        margin: "-0.5em 0 0.5em"
      },
      elementContainer: {
        display: "block",
        margin: "10px 0 20px 0",
        padding: "10px 14px",
        boxShadow:
          "rgba(50, 50, 93, 0.15) 0px 1px 3px, rgba(0, 0, 0, 0.02) 0px 1px 0px, rgba(0, 0, 0, 0.04) 0px -1px 0px",
        borderRadius: 4,
        background: "white"
      },
      cardElement: {
        base: {
          fontSize: 16,
          color: "#424770",
          letterSpacing: "0.025em",
          fontFamily: "Source Code Pro, Menlo, monospace",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#FF4136" //'#9e2146',
        }
      }
    };
  }

  onFieldChange(key, e) {
    let { value } = e.target;
    this.setState({
      [key]: value
    });
  }

  submitPaymentInfo() {
    this.setState({
      isCreatingToken: true,
      tokenCreationErrorMessage: null
    });

    this.props.stripe
      .createToken({})
      .then(({ token, error }) => {
        if (error) {
          this.setState({
            isCreatingToken: false,
            tokenCreationErrorMessage: error.message
          });
        } else {
          this.props.onToken(token);
          this.setState({
            isCreatingToken: false,
            tokenCreationErrorMessage: null
          });
        }
      })
      .catch(err => {
        this.setState({
          isCreatingToken: false,
          tokenCreationErrorMessage: err.message
        });
      });
  }

  render() {
    var styles = this.getStyles();

    return (
      <form style={styles.form}>
        <div style={styles.elementContainer}>
          <CardElement
            style={styles.cardElement}
            onReady={el => el.focus()}
            onChange={changeObject => {
              this.setState({
                ready: changeObject.complete,
                tokenCreationErrorMessage: changeObject.error
                  ? changeObject.error.message
                  : null
              });
            }}
          />
        </div>
        <div style={styles.actions}>
          {this.state.tokenCreationErrorMessage ||
          this.props.paymentInfoUpdateErrorMessage ? (
            <div style={styles.error}>
              {this.state.tokenCreationErrorMessage ||
                this.props.paymentInfoUpdateErrorMessage}
            </div>
          ) : null}
          {this.props.onCancel ? (
            <RaisedButton
              label="Cancel"
              primary={false}
              style={
                this.context.isLarge ? { marginRight: 7 } : { marginBottom: 10 }
              }
              onClick={this.props.onCancel}
            />
          ) : null}
          <RaisedButton
            label={
              this.props.submitButtonLabel ||
              (this.state.isCreatingToken ||
              this.props.paymentInfoUpdateInProgress
                ? "Submitting payment information..."
                : "Submit payment information")
            }
            primary={true}
            disabled={
              this.state.isCreatingToken ||
              this.props.paymentInfoUpdateInProgress ||
              !this.state.ready
            }
            onClick={this.submitPaymentInfo}
          />
        </div>
      </form>
    );
  }
}

export default injectStripe(PaymentMethodEntry);



// WEBPACK FOOTER //
// ./src/app/components/partials/payment-method-entry.jsx